import React, { useRef, useEffect, useState } from "react";
import "../../styles/components/StatsSection.css";

const StatsSection = () => {
  const sectionRef = useRef(null);
  const scrollContainerRef = useRef(null);

  const [translateX, setTranslateX] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const section = sectionRef.current;
      const container = scrollContainerRef.current;
      if (!section || !container) return;

      const sectionTop = section.offsetTop;
      const sectionHeight = section.offsetHeight;
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;

      // 1. Calculate vertical scroll progress (0 to 1)
      const scrollDistance = sectionHeight - windowHeight;
      let progress = (scrollY - sectionTop) / scrollDistance;

      // Clamp progress between 0 and 1
      progress = Math.min(Math.max(progress, 0), 1);

      // 2. Calculate Max Horizontal Scroll Distance
      const totalScrollWidth = container.scrollWidth - window.innerWidth;
      
      // 3. Apply translation based on progress
      const currentTranslate = totalScrollWidth * progress;

      setTranslateX(currentTranslate);

      // 4. Update background class based on scroll completion (>= 1)
      if (progress >= 1) {
        section.classList.add("scroll-complete");
      } else {
        section.classList.remove("scroll-complete");
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);

    // Initial calculation on load
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  const features = [
    {
      id: 1,
      title: "Customer Growth",
      subtitle: "Turn social views into e-commerce revenue.",
      icon: "👥",
      color: "text-green-600",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=800&q=80",
    },
    {
      id: 2,
      title: "Product Discovery",
      subtitle: "Find trending products ahead of competitors.",
      icon: "🔍",
      color: "text-purple-600",
      image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=800&q=80",
    },
    {
      id: 3,
      title: "Inventory Management",
      subtitle: "AI predicts inventory needs & prevents stockouts.",
      icon: "📦",
      color: "text-orange-600",
      image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=800&q=80",
    },
  ];

  return (
    <section ref={sectionRef} className="stats-section">
      <div className="stats-sticky-container">
        
        <div className="stats-header">
          <h2>Engineered for everyday sellers</h2>
          <p>Scroll down to explore features</p>
        </div>

        <div
          ref={scrollContainerRef}
          className="stats-horizontal-scroll"
          style={{
            transform: `translate3d(-${translateX}px, 0, 0)`,
          }}
        >
          {features.map((f) => (
            <div key={f.id} className="stats-card">
              <img src={f.image} alt={f.title} className="stats-card-image" />

              <div className="stats-card-content">
                <div className="stats-card-header">
                  <div className={`stats-icon-circle ${f.color}`}>{f.icon}</div>
                  <h3>{f.title}</h3>
                </div>

                <p>{f.subtitle}</p>
                <button className="stats-button">View Details →</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;